import React from "react";
import { DefaultProfile } from "@/images";

const StickyHeader = ({
  agent,
  property,
  isNavOpen,
  onToggleNav,
  onShare,
  onPrint,
  isPdfBusy = false
}) => {
  const headline = `${agent.fullName}, ${agent.title} at ${agent.brokerage}`;
  return (
    <header className="abr-header" role="banner">
      <div className="abr-header-inner">
        <button
          className="abr-nav-toggle"
          type="button"
          aria-label={isNavOpen ? "Close report navigation" : "Open report navigation"}
          aria-expanded={isNavOpen ? "true" : "false"}
          aria-controls="abr-section-nav"
          onClick={onToggleNav}
        >
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <a href="#hero" className="abr-brand" aria-label="The Buyer Listing Service - back to top">
          <span className="abr-brand-dot" aria-hidden="true" />
          <span>
            The Buyer Listing Service
            <span className="abr-brand-reg">&reg;</span>
          </span>
        </a>

        <div className="abr-property-pill">
          <strong>{property.addressLine1}</strong>
          {" · "}
          {property.city}, {property.state} {property.zip}
        </div>

        <div className="abr-header-agent">
          <img src={agent.photoUrl || DefaultProfile} alt={headline} />
          <div className="abr-header-agent-meta">
            <div className="abr-header-agent-name">{agent.fullName}</div>
            <div className="abr-header-agent-contact">{agent.phoneDisplay}</div>
            <div className="abr-header-agent-brokerage">{agent.brokerage}</div>
            <div className="abr-header-agent-mls">
              {agent.licenseLabel} &middot; {agent.mlsLabel}
            </div>
          </div>
        </div>

        <div className="abr-header-actions">
          <button className="abr-icon-btn" type="button" aria-label="Share this report" onClick={onShare}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="18" cy="5" r="3" />
              <circle cx="6" cy="12" r="3" />
              <circle cx="18" cy="19" r="3" />
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
            </svg>
          </button>
          <button
            className={`abr-icon-btn${isPdfBusy ? " is-busy" : ""}`}
            type="button"
            aria-label={isPdfBusy ? "Preparing PDF" : "Download PDF"}
            aria-busy={isPdfBusy ? "true" : "false"}
            disabled={isPdfBusy}
            onClick={onPrint}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <polyline points="6 9 6 2 18 2 18 9" />
              <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
              <rect x="6" y="14" width="12" height="8" />
            </svg>
          </button>
        </div>
      </div>
    </header>
  );
};

export default StickyHeader;
